export default {
    languagechangemodal: state => state
}
